import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'tag-editor',
  templateUrl: './tag-editor.component.html',
  styleUrls: ['./tag-editor.component.scss']
})
export class TagEditorComponent implements OnInit {
  @Input() tags: string[];
  @Output() tagsChange = new EventEmitter<string[]>();
  
  constructor() {
      
  } 

  ngOnInit(): void {
    console.log("Tag Editor:", this.tags);
  }

  // Call this method whenever you update tags
  updateTags(newTags: string[]) {
    this.tags = newTags;
    this.tagsChange.emit(this.tags);
  }

  onAdd(event){
    this.tags.push(event.value);
    this.updateTags(this.tags);
  }

  onRemove(event){
    this.tags = this.tags.filter(tag => tag !== event.value);
    this.updateTags(this.tags);
  }
   
}
